// Production
export const URL = "https://api.bibahobangla.com";

// Local development
// export const URL = "http://192.168.68.105:5555";
